import { LIMIT } from '@constants';
import { formatDate, getCleanedUrlParams } from '@utils';
import { pick } from 'lodash-es';

export const normalizeProducts = (data) => {
  if (!data?.length > 0) {
    return [];
  }

  const transformedData = data?.map((item) => {
    return {
      ...item,
      id: item?.id,
      billingFrequency: item?.billingFrequency || '-',
      category: item?.category || '-',
      pos: item?.pos?.length ? item?.pos?.join(', ') : '-',
      vat: item?.vat ? `${item.vat * 100}%` : '-',
      price: item?.price?.number
        ? `${item?.price?.number} ${item?.price?.currency}`
        : '-',
      createdAt: item?.createdAt
        ? formatDate(item?.createdAt, 'dd/MM/yyyy')
        : '-',
      updatedAt: item?.updatedAt
        ? formatDate(item?.updatedAt, 'dd/MM/yyyy HH:mm')
        : '-',
    };
  });

  return transformedData;
};

export const getProductsQueryParams = (payload = {}) => {
  const customFields = [];

  if (!payload?.pageSize) {
    payload.pageSize = LIMIT;
  }
  if (!payload?.page) {
    payload.page = '1';
  }

  if (!payload.order) {
    payload.order = 'desc';
    payload.orderBy = 'createdAt';
  }

  Object.keys(payload)?.forEach((key) => {
    if (customFields.includes(key)) {
      payload[`customFields.${key}`] = payload[key];
      delete payload[key];
    }
  });

  return getCleanedUrlParams(
    pick(payload, ['page', 'pageSize', 'order', 'orderBy'])
  );
};

export const normalizeProduct = (product) => {
  if (!product) return {};
  return {
    ...product,
    price: product?.price?.number ? `${product?.price?.number}` : null,
    pos: product?.pos?.length ? product?.pos?.join(', ') : '-',
    customFields: {
      ...product?.customFields,
      vehicleTypes: product?.customFields?.vehicleTypes
        ? product?.customFields?.vehicleTypes?.join(', ')
        : undefined,
      vehiclePrice: product?.customFields?.vehiclePrice
        ? product?.customFields?.vehiclePrice
        : undefined,
      deliveryPoint: product?.customFields?.deliveryPoint
        ? product?.customFields?.deliveryPoint
        : undefined,
      month: product?.customFields?.month
        ? product?.customFields?.month
        : undefined,
      durationInMonths: product?.customFields?.durationInMonths
        ? product?.customFields?.durationInMonths
        : undefined,
    },
  };
};
